import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {AUDIENCES_QUERY_KEY, TEMPLATES_QUERY_KEY} from "../queryKeys";
import {ReachTemplateToggleStatus} from "./updateTemplateStatus";
import {ReachTemplate} from "./types";

type BatchUpdateTemplateStatusVariables = {templateIds: number[]; status: ReachTemplateToggleStatus};

const batchUpdateTemplateStatus = async ({
  templateIds,
  status,
}: BatchUpdateTemplateStatusVariables): Promise<ReachTemplate[]> => {
  const response = await axiosReachInstance.patch<
    ReachTemplate[],
    AxiosResponse<ReachTemplate[]>,
    {template_ids: number[]; status: ReachTemplateToggleStatus}
  >("/templates/batch-status", {template_ids: templateIds, status});
  return response.data;
};

export const useBatchUpdateTemplateStatus = (
  options?: BaseMutationOptions<ReachTemplate[], BatchUpdateTemplateStatusVariables>
): BaseUseMutationResult<ReachTemplate[], BatchUpdateTemplateStatusVariables> => {
  return useBaseMutation<ReachTemplate[], BatchUpdateTemplateStatusVariables>(batchUpdateTemplateStatus, {
    ...options,
    resetQueriesKeyFn: () => [TEMPLATES_QUERY_KEY],
    invalidateQueriesKeyFn: () => [AUDIENCES_QUERY_KEY],
  });
};
